import React from "react";
import { withTranslation, type WithTranslation } from "react-i18next";

import { Button, Card } from "@/components/ui";
import { Icons } from "@/components/Icons";

type Props = WithTranslation & {
  children: React.ReactNode;
};

type State = {
  error: Error | null;
};

class AppErrorBoundaryBase extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[AppErrorBoundary]", error, info.componentStack);
  }

  render() {
    const { t, children } = this.props;
    const { error } = this.state;

    if (!error) return children;

    return (
      <div
        role="alert"
        style={{
          minHeight: "100%",
          display: "grid",
          placeItems: "center",
          padding: 20,
        }}
      >
        <Card padding={20} style={{ width: "100%", textAlign: "center" }}>
          <div
            style={{
              width: 58,
              height: 58,
              borderRadius: 999,
              margin: "0 auto 14px",
              display: "grid",
              placeItems: "center",
              background: "var(--surface-2)",
              color: "var(--ink-2)",
            }}
          >
            <Icons.info size={26} />
          </div>
          <div className="display" style={{ fontSize: 18, fontWeight: 800, color: "var(--ink-1)" }}>
            {t("v2.error.title")}
          </div>
          <div
            style={{
              marginTop: 6,
              fontSize: 13,
              lineHeight: 1.5,
              color: "var(--ink-2)",
            }}
          >
            {t("v2.error.body")}
          </div>
          <Button
            full
            size="lg"
            style={{ marginTop: 16 }}
            onClick={() => {
              this.setState({ error: null });
              window.location.reload();
            }}
          >
            {t("v2.error.reload")}
          </Button>
        </Card>
      </div>
    );
  }
}

export const AppErrorBoundary = withTranslation()(AppErrorBoundaryBase);
